import React, { useState } from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const ScholarshipsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const scholarships = [
    { id: 1, name: "Chevening Scholarship 2026", country: "United Kingdom 🇬🇧", funding: "100% Fully Funded (Tuition + Travel + Living)", eligibility: "Bachelor's degree with 2+ years work experience", deadline: "Nov 2026", type: "Government Grant" },
    { id: 2, name: "Fulbright Foreign Student Program", country: "United States 🇺🇸", funding: "Full Tuition + Monthly Stipend", eligibility: "Outstanding academic record & leadership background", deadline: "Oct 2026", type: "Government Grant" },
    { id: 3, name: "DAAD Study Scholarships for All Disciplines", country: "Germany 🇩🇪", funding: "€934 / Month + Health Insurance", eligibility: "Bachelor's degree completed within last 6 years", deadline: "Dec 2026", type: "Government Grant" },
    { id: 4, name: "Australia Awards Scholarship", country: "Australia 🇦🇺", funding: "Full Tuition + Return Airfare + Allowance", eligibility: "Minimum 65%+ in Bachelor's & IELTS 6.5", deadline: "Apr 2026", type: "Government Grant" },
    { id: 5, name: "Ontario Trillium Scholarship", country: "Canada 🇨🇦", funding: "CAD $40,000 / Year for 4 Years", eligibility: "PhD Applicants with top academic credentials", deadline: "Jan 2027", type: "University Merit" },
    { id: 6, name: "Government of Ireland International Education", country: "Ireland 🇮🇪", funding: "€10,000 Stipend + 100% Tuition Waiver", eligibility: "High academic achievers applying for Master's", deadline: "Mar 2026", type: "Government Grant" },
  ];

  const filtered = scholarships.filter(s => s.name.toLowerCase().includes(searchTerm.toLowerCase()) || s.country.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Banner */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Financial Guidance</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Scholarship & Grant Finder</h1>
          <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "650px" }}>
            Discover fully-funded government scholarships, university tuition waivers, and merit bursaries for international students.
          </p>

          <div className="mt-3 mx-auto" style={{ maxWidth: "450px" }}>
            <input
              type="text"
              className="form-control consultancy-form-control text-center"
              placeholder="Search scholarship by country or name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </section>

      {/* Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {filtered.map((s) => (
            <div key={s.id} className="col-lg-4 col-md-6">
              <div className="consultancy-glass-card p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="bg-warning text-dark font-weight-bold px-2 py-1 rounded small">{s.type}</span>
                    <small className="text-muted font-weight-bold">Deadline: <strong className="text-warning">{s.deadline}</strong></small>
                  </div>
                  <h5 className="font-weight-bold consultancy-gold-title mb-1">{s.name}</h5>
                  <small className="text-warning font-weight-bold d-block mb-3">{s.country}</small>

                  <div className="consultancy-pill-card mb-3">
                    <small className="text-muted font-weight-bold d-block">FUNDING COVERAGE</small>
                    <span className="text-white font-weight-bold">{s.funding}</span>
                  </div>

                  <p className="text-muted small mb-3">
                    <strong>Eligibility:</strong> {s.eligibility}
                  </p>
                </div>

                <Link to="/consultancy/book-consultation" className="consultancy-btn-gold w-100 text-center py-2">
                  Apply for Scholarship <i className="fas fa-award ml-1"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default ScholarshipsPage;
